// extracted by mini-css-extract-plugin
module.exports = {"order":"order_order__3S06G"};